//员工列表
const BusinessStaff = resolve => require(['@/components/business/pages/staff.vue'], resolve)
const BusinessPaySet = resolve => require(['@/components/business/pages/paySet.vue'], resolve)
const BusinessSetReading = resolve => require(['@/components/business/pages/setReading.vue'], resolve)
const BusinessPayDetails = resolve => require(['@/components/business/pages/payDetails.vue'], resolve)
const BusinessRoomDetails = resolve => require(['@/components/business/pages/roomDetails.vue'], resolve)
const BusinessHandleRoom = resolve => require(['@/components/business/pages/handleRoom.vue'], resolve)
const BusinessHandleChooseRoom = resolve => require(['@/components/business/pages/handleChooseRoom.vue'], resolve)
const BusinessCooperRooms = resolve => require(['@/components/business/pages/leave/cooperRooms.vue'], resolve)
// 协议单位
const Agreement = resolve => require(['@/components/agreement/index.vue'], resolve)
const AgreementDetails = resolve => require(['@/components/agreement/agreement-details.vue'], resolve)
const AddUnit = resolve => require(['@/components/agreement/add-unit.vue'], resolve)
const AccountBalance = resolve => require(['@/components/agreement/account-balance.vue'], resolve)
const AgreementOrder = resolve => require(['@/components/agreement/agreement-order.vue'], resolve)



let list = [{
    path: '/business-staff',
    name: 'BusinessStaff',
    component: BusinessStaff,
    menuShow: false
  },
  {
    path: '/business-pay-set',
    name: 'BusinessPaySet',
    component: BusinessPaySet,
    menuShow: false
  },
  {
    path: '/business-set-reading',
    name: 'BusinessSetReading',
    component: BusinessSetReading,
    menuShow: false
  },
  {
    path: '/business-pay-details',
    name: 'BusinessPayDetails',
    component: BusinessPayDetails,
    menuShow: false
  },
  {
    path: '/business-room-details',
    name: 'BusinessRoomDetails',
    component: BusinessRoomDetails,
    menuShow: false
  },
  {
    path: '/business-handle-room',
    name: 'BusinessHandleRoom',
    component: BusinessHandleRoom,
    menuShow: false
  },
  {
    path: '/business-handle-choose-room',
    name: 'BusinessHandleChooseRoom',
    component: BusinessHandleChooseRoom,
    menuShow: false
  },
  {
    path: '/business-rooms',
    name: 'BusinessCooperRooms',
    component: BusinessCooperRooms,
    menuShow: false
  },
  // 协议单位
  {
    path: '/agreement',
    name: 'Agreement',
    component: Agreement,
    menuShow: false
  },
  {
    path: '/agreement-details',
    name: 'AgreementDetails',
    component: AgreementDetails,
    menuShow: false
  },
  {
    path: '/add-unit',
    name: 'AddUnit',
    component: AddUnit,
    menuShow: false  
  },
  {
    path: '/account-balance',
    name: 'AccountBalance',
    component: AccountBalance,
    menuShow: false  
  },
  {
    path: '/agreement-order',
    name: 'AgreementOrder',
    component: AgreementOrder,
    menuShow: false
  },

]
export default list



// WEBPACK FOOTER //
// ./src/router/business.js